import { Typography } from '@mui/material';
import { makeStyles } from '@shared/theme';
import { HTMLAttributes } from 'react';

const useStyles = makeStyles(({ palette }) => ({
  root: {
    color: palette.grey[800],
    lineHeight: 1,
  },
}));

type Props = HTMLAttributes<HTMLDivElement> & {
  localeId: string;
};
const LanguageAcronym: FC<Props> = ({ localeId, className, style, ...restProps }) => {
  const { classes, cx } = useStyles();
  return (
    <Typography
      variant="subtitle2"
      className={cx(classes.root, className)}
      style={{ ...style }}
      {...restProps}
    >
      {localeId.toUpperCase()}
    </Typography>
  );
};

export default LanguageAcronym;
